import {
	PopOverStateActions,
	SHOW_POP_OVER,
	HIDE_POP_OVER,
	SET_BANNER_HAS_BEEN_SHOWN,
	SET_PLACEMENT_INFORMATION_HAS_BEEN_SHOWN,
	SET_MISSING_COVER_SECTION_HAS_BEEN_SHOWN,
	BUILD_TIP_HAS_BEEN_SHOWN,
	HIDE_BUILD_TIP,
} from './types';
import { PopOver } from 'sofa-reborn-react';

export function showPopOver(value: PopOver): PopOverStateActions {
	return {
		type: SHOW_POP_OVER,
		value,
	};
}

export function hidePopOver(value: PopOver): PopOverStateActions {
	return {
		type: HIDE_POP_OVER,
		value,
	};
}

export function setBannerHasBeenShown(value: boolean): PopOverStateActions {
	return {
		type: SET_BANNER_HAS_BEEN_SHOWN,
		value,
	};
}

export function setPlacementInformationHasBeenShown(value: boolean): PopOverStateActions {
	return {
		type: SET_PLACEMENT_INFORMATION_HAS_BEEN_SHOWN,
		value,
	};
}

export function setMissingCoverSectionHasBeenShown(value: boolean): PopOverStateActions {
	return {
		type: SET_MISSING_COVER_SECTION_HAS_BEEN_SHOWN,
		value,
	};
}

export function buildTipHasBeenShown(value: boolean): PopOverStateActions {
	return {
		type: BUILD_TIP_HAS_BEEN_SHOWN,
		value,
	};
}

export function hideBuildTip(value: boolean): PopOverStateActions {
	return {
		type: HIDE_BUILD_TIP,
		value,
	};
}
